export enum ExternalSite {
  'luki-app' = 'luki-app'
}
